<template>
  <section class="searchBrand">
    <div
      class="brands__climatizacao"
      v-if="!isSaleSolar"
    >
      <div class="title">
        <h1>BUSCAR POR MARCA</h1>
      </div>
      <hr class="line" />
      <div class="brands__item">
        <router-link to="/product?Marca=%2aMaxiflex"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/maxiflex-new.png"
            alt="Buscar produtos pela marca Maxiflex"
        /></router-link>
        <router-link to="/product?Marca=%2aAgratto"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/agratto--.png"
            alt="Buscar produtos pela marca Agratto"
        /></router-link>
        <router-link to="/product?Marca=%2aCarrier"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/carrier--.png"
            alt="Buscar produtos pela marca Carrier"
        /></router-link>
        <router-link to="/product?Marca=%2aComfee"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/comfee--.png"
            alt="Buscar produtos pela marca Comfee"
        /></router-link>
        <router-link to="/product?Marca=%2aDaikin"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/daikin--.png"
            alt="Buscar produtos pela marca Daikin"
        /></router-link>
        <router-link to="/product?Marca=%2aDelonghi"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/DeLonghi--.png"
            alt="Buscar produtos pela marca Delonghi"
        /></router-link>
        <router-link to="/product?Marca=%2aElgin"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/elgin--.png"
            alt="Buscar produtos pela marca Elgin"
        /></router-link>
        <router-link to="/product?Marca=%2aFujitsu"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/fujitsu--.png"
            alt="Buscar produtos pela marca Fujitsu"
        /></router-link>
        <router-link to="/product?Marca=%2aGree"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/gree--.png"
            alt="Buscar produtos pela marca Gree"
        /></router-link>
        <router-link to="/product?Marca=%2aIBBL"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/ibbl--.png"
            alt="Buscar produtos pela marca IBBL"
        /></router-link>
        <router-link to="/product?Marca=%2aLG"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/lg.png"
            alt="Buscar produtos pela marca LG"
        /></router-link>
        <router-link to="/product?Marca=%2aLorenzetti"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/lorenzetti--.png"
            alt="Buscar produtos pela marca Lorenzetti"
        /></router-link>
        <router-link to="/product?Marca=%2aMidea"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/midea--.png"
            alt="Buscar produtos pela marca Midea"
        /></router-link>
        <router-link to="/product?Marca=%2aSpringer%20Midea"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/springer--.png"
            alt="Buscar produtos pela marca Springer Midea"
        /></router-link>
        <router-link to="/product?Marca=%2aTCL"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/tc-logo.png"
            alt="Buscar produtos pela marca TCL"
        /></router-link>
        <router-link to="/product?Marca=%2aTesto"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/testo--.png"
            alt="Buscar produtos pela marca Testo"
        /></router-link>
        <router-link to="/product?Marca=%2aTrane"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/trane--.png"
            alt="Buscar produtos pela marca Trane"
        /></router-link>
        <router-link to="/product?Marca=%2aVentisol"
          ><img
            loading="lazy"
            class="brands__image"
            src="../../assets/ventisol--.png"
            alt="Buscar produtos pela marca Ventisol"
        /></router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      isSaleSolar: false,
    };
  },
  async created() {
    const isSaleSolar = JSON.parse(localStorage.getItem("isSaleSolar"));
    this.isSaleSolar = isSaleSolar;
  },
};
</script>

<style lang="scss" scoped>
.searchBrand {
  max-width: 90%;
  margin: 0 auto;
  padding-top: 50px;

  @media (min-width: 1920px) {
    max-width: 70%;
  }
}

.title {
  display: flex;
  justify-content: center;
  margin: 40px 0 8px 0;
  font-size: 0.95rem;
  color: var(--standardGreen);
}

.line {
  width: 90px;
  background-color: var(--standardGreen);
  height: 3px;
  border: none;
  margin: 0 auto;
}

.brands {
  &__climatizacao {
    display: flex;
    flex-direction: column;
  }

  &__item {
    display: flex;
    align-items: center;
    overflow-x: scroll;
    margin-top: 35px;

    a {
      margin: 0 20px;
    }
  }
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--customDarkGreen);
}

::-webkit-scrollbar {
  height: 8px;
  background: var(--customGray-100);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: var(--customBlue);
  border-radius: 10px;
}
</style>